export const ACTIVE_STEP_INDEX = 'active_step_index';
export const IS_TRANSITIONING = 'is_transitioning';
export const STEPS = 'steps';
